var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColorsVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 314,
    viewBox: "0 0 21 314",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "colors-vertical",
    transform: "translate(-1198 -998)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_194",
    "data-name": "Rectangle 194",
    width: 21,
    height: 103,
    transform: "translate(1198 998)",
    fill: "#086d84"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_196",
    "data-name": "Rectangle 196",
    width: 21,
    height: 30,
    transform: "translate(1198 1195)",
    fill: "#75b94e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_197",
    "data-name": "Rectangle 197",
    width: 21,
    height: 29,
    transform: "translate(1198 1225)",
    fill: "#792e7e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_198",
    "data-name": "Rectangle 198",
    width: 21,
    height: 27,
    transform: "translate(1198 1254)",
    fill: "#e4032e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199",
    "data-name": "Rectangle 199",
    width: 21,
    height: 31,
    transform: "translate(1198 1281)",
    fill: "#ef7d00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_200",
    "data-name": "Rectangle 200",
    width: 21,
    height: 94,
    transform: "translate(1198 1101)",
    fill: "#044251"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorsVertical);
export default __webpack_public_path__ + "static/media/colors-vertical.54ff338e25ef5cd6341377c3e0dd72a0.svg";
export { ForwardRef as ReactComponent };